import React, { useState } from 'react';
import { NavLink, Route, Switch } from "react-router-dom";
import Profile from './Profile';
import { setKey, setStringifiedKey } from "../store/actions";
import Cookies from 'universal-cookie';
import keys from '../store/keys';
import { connect } from "react-redux";
import ChangePassword from "./ChangePassword";
import PersonalInformation from './PersonalInformation';
import DeliveryAddress from './DeliveryAddress';
import userService from '../services/user';

function Settings({ session, setKey, setStringifiedKey, ...props }) {

    const [deliveryAddress, setDeliveryAddress] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    
    const handleSubmit = e => {
        e.preventDefault();
        setErrorMessage('');
        setSuccessMessage("");
        setKey(keys.isLoading, true);
        
        userService.updateDeliveryAddress(session.token, deliveryAddress)
            .then(result => {
                if (result.error) {
                    setErrorMessage(result.error);
                    setKey(keys.isLoading, false);
                    return;
                }

                setErrorMessage('');
                setSuccessMessage(`Delivery address updated successfully!.`);
                setKey(keys.isLoading, false);
                const data = result.data;
				setStringifiedKey(keys.user, data);
            });
    }

    return (
        <>
            <div className="row mt-10">
                <div className="col">
                    <p className="cart-title">Settings</p>
                </div>
            </div>
            <div className="row">
                <div className="col-3">
                    <div className="nav flex-column nav-pills nav-settings" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                        <button className="nav-link active text-start" id="v-pills-home-tab" data-bs-toggle="pill" data-bs-target="#v-pills-home" type="button" role="tab" aria-controls="v-pills-home" aria-selected="true">Update password</button>
                        <button className="nav-link text-start" id="v-pills-profile-tab" data-bs-toggle="pill" data-bs-target="#v-pills-profile" type="button" role="tab" aria-controls="v-pills-profile" aria-selected="false">Personal information</button>
                        <button className="nav-link text-start" id="v-pills-messages-tab" data-bs-toggle="pill" data-bs-target="#v-pills-messages" type="button" role="tab" aria-controls="v-pills-messages" aria-selected="false">Delivery address</button>
                    </div>
                </div>
                <div className="col-9">
                    <div className="tab-content" id="v-pills-tabContent">
                        <div className="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                            <ChangePassword />
                        </div>
                        <div className="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                            <PersonalInformation />
                        </div>
                        <div className="tab-pane fade" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">
                            <DeliveryAddress
                                errorMessage={errorMessage}
                                successMessage={successMessage} 
                                onChange={setDeliveryAddress} 
                                showButton={true} 
                                handleSubmit={handleSubmit} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (store) => ({
    session: store.session,
});

const mapDispatchToProps = (dispatch) => ({
    setKey: (key, value) => dispatch(setKey(key, value)),
    setStringifiedKey: (key, value) => dispatch(setStringifiedKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Settings);